module.exports = __webpack_public_path__ + "img/lbl-01.0e88caf8.png";